module.exports = __webpack_public_path__ + "static/media/HistoryH.3093f7d9.jpg";